module.exports = {
  siteTitle: 'Danny | Senior Software Engineer',
  siteDescription: '',
  siteKeywords:
    'Danny, Danny, codecarrier1, software engineer, front-end engineer, web developer, javascript',
  siteUrl: 'https://dannyfolio.netlify.app',
  siteLanguage: 'en_US',
  googleAnalyticsID: '',
  googleVerification: '',
  name: 'Danny',
  location: 'MB, Canada',
  email: 'dannyjin17@gmail.com',
  github: 'https://github.com/codecarrier1',
  twitterHandle: '',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/codecarrier1',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/danny-9458141b0/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
